import React from 'react';
import { useState } from 'react';
import axios from 'axios';
import { Button, InputText, InputTextarea, Typography, TagHighlight } from '@jota-ds/lib-react'

export default function Six() {
    const [modal, setModal] = useState();
    const [response, setResponse] = useState();
    const [formInputName, setFormInputName] = useState();
    const [formInputEmail, setFormInputEmail] = useState();
    const [formInputPhone, setFormInputPhone] = useState();
    const [formInputJobTitle, setFormInputJobTitle] = useState();
    const [formInputMessage, setFormInputMessage] = useState();

    React.useEffect(() => {
        if (modal) {
            document.body.classList.add("overflow-hidden");
            let validations = document.getElementsByClassName('jota-InputText__input');
            for (var i = 0; i < validations.length; ++i) {
                validations[i].required = true;
            }

            let validationsTextarea = document.getElementsByClassName('jota-TextArea__textarea');
            for (let i = 0; i < validationsTextarea.length; ++i) {
                validationsTextarea[i].required = true;
            }
        } else {
            document.body.classList.remove("overflow-hidden");
        }
    }, [modal])

    const send = (e) => {
        e.preventDefault();
        const cors = "https://cors.meiuca.design";
        const params = `u=f9e8d7cd0ae2b64f93125e880&id=00b116e1f0&EMAIL=${formInputEmail}&FNAME=${formInputName}&CELULAR=${formInputPhone}&CARGO=${formInputJobTitle}&MENSAGEM=${formInputMessage}`;
        let config = {
            method: "get",
            url: `${cors}/https://mc.us18.list-manage.com/signup-form/subscribe?${params}`,
            headers: {
                'X-Requested-With': "LP Bilhete Dourado"
            }
        };

        axios(config)
            .then((response) => {
                setResponse("success");
            })
            .catch((error) => {
                setResponse("error");
            });
    }

    return (
        <section className="six pt-large d-flex align-items-center">
            <div className="container pb-5">
                <div className="row">
                    <div className="col-md-7">
                        <div className="caption">
                            <Typography component="paragraph">
                                INICIATIVAS
                            </Typography>
                        </div>

                        <div className="mb-4">
                            <Typography component="heading" size="large">
                                Bilhetes sociais
                            </Typography>
                        </div>

                        <div className="mb-5 muted">
                            <Typography component="paragraph" size="small">
                                Temos parcerias com projetos e comunidades <br />
                                que estão fazendo a diferença no mercado de <br />
                                design e tecnologia. Se você acha que uma <br />
                                dessas iniciativas representa você, entre em <br />
                                contato e saiba mais.
                            </Typography>
                        </div>

                        <div className="d-flex parceiros-flex">
                            <img className="img-fluid mb-5" alt="" src="/assets/logo-FESAI.svg" />
                            <img className="img-fluid mb-5" alt="" src="/assets/logo-Pretux.svg" />
                            <img className="img-fluid mb-5" alt="" src="/assets/logo-Todas.svg" />
                            <img className="img-fluid mb-5" alt="" src="/assets/logo-ux-minas-pretas.svg" />
                            <img className="img-fluid mb-5" alt="" src="/assets/logo-vagasux.svg" />
                        </div>
                    </div>
                    <div className="col-md-5 d-none d-md-flex justify-content-end">
                        <div>
                            <img className="img-fluid mb-5" alt="" src="/assets/nuvem.svg" />
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end pb-large">
                    <span className="pointer" onClick={() => setModal(true)}>
                        <Typography component="heading" size="x-small">
                            Indicar parcerias <img className="img-fluid ms-3" alt="" src="/assets/seta.svg" />
                        </Typography>
                    </span>
                </div>

                <div className="box-blue mb-5">
                    <div className="row">
                        <div className="col-md-3">
                            <img className="img-fluid d-block" alt="" src="/assets/vector.svg" />
                        </div>
                        <div className="col-md-2 d-flex align-items-center justify-content-center justify-content-md-start">
                            <div>
                                <div className="mb-4 btn-rosa d-flex justify-content-center">
                                    <TagHighlight
                                        label="Novo curso"
                                    />
                                </div>
                                <img className="img-fluid logo-dss" alt="" src="/assets/logo-DSS.svg" />
                            </div>
                        </div>

                        <div className="col-md-4 pt-5 pb-5 d-flex align-items-center justify-content-center justify-content-md-start black">
                            <Typography component="heading" size="small">
                                Aprenda planejar, <br />
                                projetar e implementar <br />
                                um Design System.
                            </Typography>
                        </div>

                        <div className="col-md-3 pt-5 pb-5 d-flex align-items-center justify-content-center justify-content-md-end btn-action">
                            <Button
                                label="Vendas abertas"
                                type="primary"
                                handleClick={() => window.location.replace('https://learn.meiuca.co/')}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {(modal) &&
                <>
                    <div data-aos="fade" data-aos-once="true" className="parceria bg-white d-flex flex-column align-items-center">
                        <div className="close">
                            <img onClick={() => setModal(false)} className="img-fluid pointer" alt="" src="/assets/close.svg" />
                        </div>
                        <div className="row d-flex justify-content-center card-body">
                            <div className="col-md-6">
                                <div className="mt-116 mb-4 title">
                                    <Typography component="heading" size="large">
                                        Fale com a gente!
                                    </Typography>
                                </div>

                                <div className="mb-5 subtitle">
                                    <Typography component="paragraph">
                                        Deixe sua mensagem que em breve a gente te retorna :)
                                    </Typography>
                                </div>

                                <form id="form-parcerias" action="" onSubmit={send}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <InputText
                                                label="Nome"
                                                placeholder="Digite seu nome aqui..."
                                                helperText="Preencha este campo, por favor."
                                                handleChange={setFormInputName}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <InputText
                                                label="E-mail"
                                                placeholder="Digite seu e-mail aqui..."
                                                helperText="Preencha este campo, por favor."
                                                handleChange={setFormInputEmail}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <InputText
                                                label="Celular"
                                                placeholder="(00) 00000-0000"
                                                helperText="Preencha este campo, por favor."
                                                handleChange={setFormInputPhone}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <InputText
                                                label="Cargo"
                                                placeholder="Qual seu cargo?"
                                                helperText="Preencha este campo, por favor."
                                                handleChange={setFormInputJobTitle}
                                            />
                                        </div>

                                        <div className="col-md-12">
                                            <InputTextarea
                                                label="Escreva sua mensagem"
                                                placeholder="Sua mensagem aqui..."
                                                maxLength={255}
                                                handleChange={(evt) => { setFormInputMessage(evt.target.value) }}
                                            />
                                        </div>

                                        <div className="mt-40 col-md-12 d-flex justify-content-end">
                                            <Button
                                                label="Enviar"
                                                type="primary"
                                                handleClick={() => document.getElementById('form-parcerias').submit}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    {(response === 'success') &&
                        <div data-aos="slide-right" data-aos-once="true" className="success d-flex flex-column justify-content-center">
                            <div className="mb-3 d-flex justify-content-center black">
                                <Typography component="heading" size="x-large">Boooa!</Typography>
                            </div>
                            <div className="mb-5 paragraph mb-3 d-flex justify-content-center">
                                <Typography component="heading" size="x-small">
                                    Muito obrigado pela indicação.<br/>
                                    Vamos olhar com carinho e em breve entraremos em contato por email.
                                </Typography>
                            </div>
                            <div className="d-flex justify-content-center">
                                <Button
                                    label="Voltar ao início"
                                    type="primary"
                                    handleClick={() => window.location.replace('/')}
                                />
                            </div>
                        </div>
                    }
                    {(response === 'error') &&
                        <div data-aos="slide-right" data-aos-once="true" className="error d-flex flex-column justify-content-center">
                            <div className="d-flex justify-content-center mb-3">
                                <Typography component="heading" size="x-large">Ops!</Typography>
                            </div>
                            <div className="d-flex justify-content-center mb-5">
                                <Typography component="heading" size="x-small">
                                    Parece que alguma coisa deu<br/>
                                    errado por aqui.
                                </Typography>
                            </div>

                            <div className="mb-5 d-flex justify-content-center">
                                <Button
                                    label="Tentar novamente"
                                    type="primary"
                                    handleClick={() => setResponse('form')}
                                />
                            </div>
                            <div className="mt-5 pt-5 d-flex justify-content-center">
                                <img alt="" src="/assets/vector1.svg" />
                            </div>
                        </div>
                    }
                </>
            }
        </section>
    )
}